import Http from "./http";

export const updateGroupProductFeatureAPI = (data, options) => {
  return Http.post("admin/group/updateGroupProductFeature", data, options);
};
